import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {alabaster} from '/theme/color/on.color';
import {graniteGray} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  cardContainer: {
    backgroundColor: alabaster,
    marginVertical: indent * 0.1,
    marginHorizontal: indent * 0.7,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
  },
  titleText: {
    fontSize: 16,
    color: graniteGray,
    textAlign: 'left',
  },
  description: {
    display: 'flex',
    textAlign: 'right',
    marginLeft: 'auto',
  },
});
